var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('div',{style:({
          display: 'flex',
          flexFlow: 'row wrap',
          justifyContent: 'space-around',
        })},_vm._l((_vm.offers),function(offer){return _c('DashEarnItem',{key:offer.slug,style:({
            marginBottom: '25px',
          }),attrs:{"title":offer.title,"coins":offer.coins,"backgroundImage":offer.img,"slug":offer.slug}})}),1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }